import React from 'react';
import { useHistory } from 'react-router-dom';
import {
    makeStyles,
    Grid,
    Paper,
    Dialog,
    AppBar,
    Toolbar,
    Slide,
    IconButton,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import CircularProgress from '@material-ui/core/CircularProgress';
import Balance from '../../LeaveApplication/component/Balance';
import RecentLeave from '../../LeaveApplication/component/RecentLeave';
import RecentLeaveCollection from '../../Function/RecentLeaveCollection';
import customAxios from '../../API/customAxios';
import Details from '../../MyLeave/component/Details';
import { useIntl } from 'react-intl';
import { checkUndefined } from '../../Function/globalFunction';
import MiniTable from '../../UIComponent/MiniTable';
import CompLeaveCollection from '../../Function/CompLeaveCollection';
import ViewCompLeaveForm from '../../CompLeaveRequest/component/Form';
import { Container } from '@mui/material';
import CompLeaveReqsCollection from '../../Function/CompLeaveReqs';

const useStyles = makeStyles((theme) => ({
    appBar: {
        position: 'relative',
        backgroundColor: '#232F3E',
    },
    container: {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
    },
    mainPaper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'hidden',
        flexDirection: 'column',
        // maxWidth: '1150px',
    },
    subPaper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
    },
    marginBottom: {
        marginBottom: theme.spacing(2),
    },
    circularProgress: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: theme.spacing(1),
    },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction='up' ref={ref} {...props} />;
});

export default function ViewCompLeaveReq({ handleClose, open, showId, actionPage, isNewCompLeave, backToTable }) {
    const mode = window.global.viewMode;
    const classes = useStyles();
    const intl = useIntl();
    const history = useHistory();
    const [showCompetent, setShowCompetent] = React.useState(false);
    const [application, setApplication] = React.useState({});
    const [showDetail, setShowDetail] = React.useState(false);
    const [balanceData, setBalanceData] = React.useState([]);
    const [isApprover, setIsApprover] = React.useState(false);
    const [approveId, setApproveId] = React.useState('');
    const hrAdmin = localStorage.getItem('isHRAdminOpen');
    React.useEffect(() => {
        customAxios.get(`/get_team_leave/${showId}?isNewCompLeave=${isNewCompLeave}&isHrView=${hrAdmin}`)
            .then(res => {
                if (String(res.data.status) !== window.global.withdrawn) {
                    setShowDetail(true);
                } else {
                    setShowDetail(false);
                }

                if (res.data.is_approver === true) {
                    setIsApprover(true);
                    setApproveId(res.data.processing_application_id);
                } else {
                    setIsApprover(false);
                    setApproveId('');
                }

                setApplication(res.data);
                setShowCompetent(true);
                setBalanceData(CompLeaveCollection(res.data['comp_leave_balance'], intl));
            }).catch(error => {
            console.error(error);
            history.push('/home');

        })
    }, []);

    return (
        <Dialog
            fullScreen
            open={open}
            onClose={handleClose}
            TransitionComponent={Transition}
            PaperProps={{
                style: {
                    backgroundColor: '#f0f2f5',
                    boxShadow: 'none',
                },
            }}
        >
            <AppBar className={classes.appBar}>
                <Toolbar>
                    <IconButton
                        edge='start'
                        color='inherit'
                        onClick={handleClose}
                        aria-label='close'
                    >
                        <CloseIcon />
                    </IconButton>
                </Toolbar>
            </AppBar>
            <Container 
                className={classes.container}
                maxWidth='xxl'
            >
                {showCompetent ? (
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={12} lg={9}>
                            <Paper className={classes.mainPaper}>
                                <ViewCompLeaveForm
                                    mode={mode}
                                    application={application}
                                    isApprover={isApprover}
                                    approveId={approveId}
                                    approveMode={window.global.myTeamApprove}
                                    backToTable={backToTable}
                                />
                            </Paper>
                        </Grid>
                        <Grid item xs={12} md={12} lg={3}>
                            <Paper className={`${classes.subPaper} ${classes.marginBottom}`}>
                                <MiniTable rows={balanceData}/>
                            </Paper>
                            {showDetail && (
                                <Paper className={classes.subPaper}>
                                    <Details
                                        handleClose={null}
                                        open={null}
                                        showId={showId}
                                        page='View Comp Leave Req'
                                    />
                                </Paper>
                            )}
                        </Grid>
                    </Grid>
                ) : (
                    <div className={classes.circularProgress}>
                        <CircularProgress />
                    </div>
                )}
            </Container>
        </Dialog>
    );
}
